import {useListView} from '../../core/ListViewProvider'
import {AdministratorsListToolbar} from './AdministratorsListToolbar'
import {AdministratorsListGrouping} from './AdministratorsListGrouping'
import {AdministratorsSearchComponent} from './AdministratorsSearchComponent'
import {TOKENS} from '../../../../../../components/design-system'

type PropTypes = {
  showAddAdministrator?: boolean
}

const AdministratorsListHeader = ({showAddAdministrator = true}: PropTypes) => {
  const {selected} = useListView()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: TOKENS.spacing.md,
        padding: '14px 18px',
        borderBottom: `1px solid ${TOKENS.color.border}`,
        background: TOKENS.color.card,
      }}
    >
      <AdministratorsSearchComponent />
      <div>
        {selected.length > 0 ? <AdministratorsListGrouping /> : <AdministratorsListToolbar showAddAdministrator={showAddAdministrator} />}
      </div>
    </div>
  )
}

export {AdministratorsListHeader}
